export default "__VITE_ASSET__34ee2170__"